<template>
    <div class="addressBody clearfix">

        <div v-show="addresses.length == 0" class="addressNoData">
            <img src="../assets/imgs/address_no_data.png" alt=""/>
            <p>暂无收货地址</p>
        </div>
        <div class="addressList">
            <ul>
                <li v-for="address in addresses" :key="address.id">
                    <div class="addressListTop">
                        <div>
                            <p><i>{{address.name}}</i><i>{{address.phone}}</i><i v-show="address.defaultFlag" class="defaultAddress">默认</i></p>
                            <p>{{address.province}}{{address.city}}{{address.district}}{{address.address}}</p>
                        </div>
                        <router-link class="edit" :to="{
                            path:'/prod/user/receiver/add',
                            query:{
                                addressId:address.id,
                                userId:address.accountId,
                                userName:address.name,
                                userTel:address.phone,
                                userProvince:address.province,
                                userProvinceCode:address.provinceCode,
                                userCity:address.city,
                                userCityCode:address.cityCode,
                                userDistrict:address.district,
                                userDistrictCode:address.districtCode,
                                userAddress:address.address
                            }
                        }">
                            <img src="../assets/imgs/address_item_edit.png" alt=""/>
                        </router-link>
                    </div>
                    <div class="addressListBottom">
                        <a class="default" @click="setDefaultAddress(address)">
                            <img :src="address.defaultFlag ? defaultImg[0] : defaultImg[1]" alt=""/>
                            设置为默认地址
                        </a>
                        <a class="delete" @click="deleteAddress(address)">
                            删除
                        </a>
                    </div>
                </li>
            </ul>
        </div>
        <div class="addressBottom">
            <router-link class="addBtn" :to="{
                path:'/prod/user/receiver/add',
                query:{
                    addressId:'',
                    userId:this.userId,
                    userName:'',
                    userTel:'',
                    userProvince:'',
                    userProvinceCode:'',
                    userCity:'',
                    userCityCode:'',
                    userDistrict:'',
                    userDistrictCode:'',
                    userAddress:''
                }
            }">
                +新建售后地址
            </router-link>
        </div>
    </div>
</template>

<script>
    import {getAddressListByUserId, deleteAddressById, setDefaultAddressById} from '../api'
    import defaultImgSelect from '../assets/imgs/address_select.png'
    import defaultImgNoSelect from '../assets/imgs/address_no_select.png'
    import { Toast } from 'vant';
    export default {
        name:'ShopMallAddressList',
        props:['userId', 'phone'],
        data(){
            return {
                addresses:[],
                defaultImg:[defaultImgSelect,defaultImgNoSelect]
            }
        },
        methods:{
            async deleteAddress(address){
                let result = await deleteAddressById(address.id)
                if(result.code === 0){
                    this.getAddressList(this.userId)
                }else{
                    Toast({message: result.message, position: 'bottom'})
                    
                }
            },
            async setDefaultAddress(address){
                let result = await setDefaultAddressById(address.id)
                if(result.code === 0){
                    this.getAddressList(this.userId)
                }else{
                    Toast({message: result.message, position: 'bottom'})
                }
            },
            async getAddressList(userId){
                let result = await getAddressListByUserId(userId)
                if(result.code === 1){
                    this.addresses = result.data
                }else{
                    Toast({message: result.message, position: 'bottom'})
                }
            }
        },
        mounted(){
            this.getAddressList(this.userId)
        }
    }
</script>

<style scoped>
    .addressBody{
        height: 100%;
        background-color: #F0EFF4;
        padding-bottom: 30.4vw;
    }
    .addressBody .addressNoData{
        width: 49.33333vw;
        margin: 15.2vw auto 0;
    }
    .addressBody .addressNoData img{
        width: 49.33333vw;
        height: 49.33333vw;
    }
    .addressBody .addressNoData p{
        text-align: center;
        margin-top: 3.46666vw;
    }
    .addressBody .addressList li{
        width: 85.06666vw;
        height: 30.4vw;
        margin: 1.86666vw auto 0;
        background-color: #FFFFFF;
        padding-left: 5.86666vw;
        padding-right: 5.06666vw;
        border-radius: 2.13333vw;
        
    }
    .addressBody .addressList li .addressListTop{
        display: flex;
        height: 20.8vw;
        border-bottom: 1px solid #6A421F;
        align-items: center;
        font-size: 3.73333vw;
        color: #6A421F;
    }

    .addressBody .addressList li .addressListTop i{
        display: inline-block;
        height: 5.33333vw;
        line-height: 5.33333vw;
    }

    .addressBody .addressList li .addressListTop .defaultAddress{
        background-color: #C83036;
        border-radius: 0.8vw;
        width: 9.6vw;
        font-size: 3.2vw;
        color: #FFFFFF;
        text-align: center;
    }
    .addressBody .addressList li .addressListTop p:last-child{
        margin-top: 2.4vw;
        font-weight: 500;
        line-height: 4.26666vw;
    }
    .addressBody .addressList li .addressListTop p i{
        margin-right: 2.66666vw;
    }

    .addressBody .addressList li .addressListTop>div{
        flex: 1;
    }

    .addressBody .addressList li .addressListTop .edit{
        display: block;
        height: 11.73333vw;
        width: 11.73333vw;
    }

    .addressBody .addressList li .addressListTop .edit img{
        height: 7.73333vw;
        width: 7.73333vw;
    }

    .addressBody .addressList li .addressListBottom{
        display: flex;
        height: 9.6vw;
        align-items: center;
    }

    .addressBody .addressList li .addressListBottom .default{
        flex: 1;
        font-size: 3.73333vw;
        color: #6A421F;
    }

    .addressBody .addressList li .addressListBottom .default img{
        width: 3.46666vw;
        height: 3.46666vw;
    }

    .addressBody .addressList li .addressListBottom .delete{
        display: block;
        width: 11.73333vw;
        height: 9.6vw;
        line-height: 9.6vw;
        text-align: center;
        font-size: 3.73333vw;
        color: #6A421F;
    }
    .addressBody .addressBottom{
        width: 100%;
        height: 30.4vw;
        position: fixed;
        bottom: 0;
        background-color: #FFFFFF;
    }
    .addressBody .addressBottom .addBtn{
        background:linear-gradient(0deg, #F4D19D, #F0B866);
        margin: 5.06666vw auto 0;
        font-size: 4.8vw;
        color: #6A421F;
        width: 84.26666vw;
        height: 11.73333vw;
        border-radius: 5.86666vw;
        text-align: center;
        line-height: 11.73333vw;
        display: block;
    }
</style>